import React, { lazy } from 'react';
import { Instagram, MapPin, Phone, Clock, MessageCircle } from 'lucide-react';
import { translations } from '../utils/translations';
interface FooterProps {
  lang: string;
}
export function Footer({
  lang
}: FooterProps) {
  const t = translations[lang as keyof typeof translations] || translations.en;
  return <footer className="bg-[#050505] border-t border-gray-900 pt-16 pb-8 px-4" data-id="element-45">
      <div className="max-w-6xl mx-auto" data-id="element-46">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-47">
          {/* Brand & Social */}
          <div className="flex flex-col" data-id="element-48">
            <div className="w-28 h-28 mb-6 flex items-center justify-center" data-id="element-49">
              <img src="https://cdn.magicpatterns.com/uploads/gbD8hKufJEC7SSgGgGcMCM/IMG_8096.jpg" alt="OJ Auto Group LLC Logo" className="max-w-full max-h-full object-contain" data-id="element-50" />
            </div>
            <h3 className="text-2xl text-white mb-4" data-id="element-51">OJ AUTO GROUP LLC</h3>
            <a href="https://instagram.com/ojautogrouptx_" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-400 hover:text-brand-red transition-colors font-body" data-id="element-52">
              <Instagram className="w-5 h-5 mr-2" data-id="element-53" />
              @ojautogrouptx_
            </a>
          </div>

          {/* Contact Info */}
          <div data-id="element-54">
            <h4 className="text-xl text-white mb-6 border-b border-gray-800 pb-2 inline-block" data-id="element-55">
              {t.contactUs}
            </h4>
            <ul className="space-y-4 font-body text-gray-400" data-id="element-56">
              <li className="flex items-start" data-id="element-57">
                <Phone className="w-5 h-5 mr-3 text-brand-red shrink-0 mt-0.5" data-id="element-58" />
                <a href="tel:+17862232564" className="hover:text-white transition-colors" data-id="element-59">
                  (786) 223-2564
                </a>
              </li>
              <li className="flex items-start" data-id="element-60">
                <Phone className="w-5 h-5 mr-3 text-brand-red shrink-0 mt-0.5" data-id="element-61" />
                <a href="tel:+16783347552" className="hover:text-white transition-colors" data-id="element-62">
                  (678) 334-7552
                </a>
              </li>
              <li className="flex items-start" data-id="element-63">
                <MessageCircle className="w-5 h-5 mr-3 text-[#25D366] shrink-0 mt-0.5" data-id="element-64" />
                <a href="https://wa.link/7opyfb" className="hover:text-white transition-colors" data-id="element-65">
                  {t.whatsappUs}
                </a>
              </li>
              <li className="flex items-start" data-id="element-66">
                <Clock className="w-5 h-5 mr-3 text-brand-red shrink-0 mt-0.5" data-id="element-67" />
                <span data-id="element-68">{t.openHours}</span>
              </li>
            </ul>
          </div>

          {/* Map */}
          <div className="lg:col-span-2" data-id="element-69">
            <h4 className="text-xl text-white mb-6 border-b border-gray-800 pb-2 inline-block" data-id="element-70">
              {t.serviceArea}
            </h4>
            <div className="w-full rounded-lg border border-gray-800 overflow-hidden" data-id="element-71">
              <iframe title="OJ Auto Group LLC - Serving All of Georgia, USA" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3444089.457498498!2d-85.46288045!3d32.6781248!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f136c51d5f8157%3A0x6684bc10ec4c2e0e!2sGeorgia%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000" width="100%" height="220" style={{
              border: 0,
              filter: 'invert(90%) hue-rotate(180deg) brightness(0.8) contrast(1.2)'
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-72"></iframe>
            </div>
            <div className="mt-3 flex items-center gap-2 text-gray-400 font-body text-sm" data-id="element-73">
              <MapPin className="w-4 h-4 text-brand-red shrink-0" data-id="element-74" />
              <span data-id="element-75">{t.serviceAreaDesc}</span>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-900 pt-8 text-center" data-id="element-76">
          <p className="text-gray-600 font-body text-sm" data-id="element-77">{t.copyright}</p>
        </div>
      </div>
    </footer>;
}